// import { Routes, Route } from "react-router-dom";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";

// // Pages
// import Home from "../Home/Home";
// import AboutUs from "../AboutUs/AboutUs";
// import Services from "../Services/Services";
// import Gallery from "../Gallery/Gallery";
// import ContactUs from "../ContactUs/ContactUs";
// import Produts from "../OurProducts/OurProducts";
// import Login from "../Auth/Login";
// import Signup from "../Auth/Signup";
// import UserProfile from "../UserProfile/UserProfile";
// import ProductForm from "../ProductForm/ProductForm";
// import EditUserProfile from "../EditUserProfile/EditUserProfile";
// import FloatingContactButtons from "../FloatingContactButtons/FloatingContactButtons";

// export default function Main() {
//   return (
//     <div className="bg-green-100 flex flex-col items-center min-h-screen">
//       {/* ✅ Common Header on all pages */}
//       <Header />

//       {/* ✅ Page Content */}
//       <main className="main-content w-full max-w-2xl text-center flex-grow">
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/about" element={<AboutUs />} />
//           <Route path="/services" element={<Services />} />
//           <Route path="/gallery" element={<Gallery />} />
//           <Route path="/contact" element={<ContactUs />} />
//           <Route path="/products" element={<Produts />} />
//           {/* <Route path="/login" element={<Login />} />
//           <Route path="/signup" element={<Signup />} />
//           <Route path="/profile" element={<UserProfile />} />
//           <Route path="/add-product" element={<ProductForm />} />
//           <Route path="/product/:id" element={<ProductForm />} />
//           <Route path="/edit-profile" element={<EditUserProfile />} /> */}


//           {/* ✅ Fallback for unknown routes */}
//           {/* <Route
//             path="*"
//             element={
//               <div className="p-8 text-red-600 text-xl font-semibold">
//                 404 - Page Not Found
//               </div>
//             }
//           /> */}
//         </Routes>
//         <FloatingContactButtons/>
//       </main>

//       {/* ✅ Common Footer on all pages */}
//       <Footer />
//     </div>
//   );
// }

import { Routes, Route } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

// Pages
import Home from "../Home/Home";
import AboutUs from "../AboutUs/AboutUs";
import Services from "../Services/Services";
import Gallery from "../Gallery/Gallery";
import ContactUs from "../ContactUs/ContactUs";
import Products from "../OurProducts/OurProducts"; // ✔ Fix spelling
import FloatingContactButtons from "../FloatingContactButtons/FloatingContactButtons";

export default function Main() {
  return (
    <div className="bg-green-100 flex flex-col items-center min-h-screen">

      <Header />

      <main className="main-content w-full max-w-2xl text-center flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/products" element={<Products />} />
        </Routes>

        <FloatingContactButtons />
      </main>

      <Footer />
    </div>
  );
}

